import { render, staticRenderFns } from "./PosSalesReport.vue?vue&type=template&id=573bc907&scoped=true"
import script from "./PosSalesReport.vue?vue&type=script&lang=js"
export * from "./PosSalesReport.vue?vue&type=script&lang=js"
import style0 from "./PosSalesReport.vue?vue&type=style&index=0&id=573bc907&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573bc907",
  null
  
)

export default component.exports